import React, { useEffect } from 'react';

const CognitoLoginSimple = () => {
    useEffect(() => {
        console.log('CognitoLoginSimple component mounted');
        console.log('Current URL:', window.location.href);
        console.log('Current pathname:', window.location.pathname);
        
        // Clear any existing auth data
        localStorage.removeItem('access_token');
        localStorage.removeItem('refresh_token');
        localStorage.removeItem('auth_method');
        localStorage.removeItem('user_data');
        sessionStorage.removeItem('authUser');
        
        console.log('CognitoLoginSimple - Auth data cleared');
    }, []);

    return (
        <div style={{ padding: '2rem', textAlign: 'center' }}>
            <h1>🔐 Cognito Login Test Page</h1>
            <p>If you can see this, the route is working!</p>
            <p>URL: /login/cognito</p>
            <p>Current URL: {window.location.href}</p>
            <div style={{ marginTop: '2rem' }}>
                <a href="/login">← Back to Regular Login</a>
                <br />
                <a href="/login/cognito">🔄 Refresh This Page</a>
            </div>
        </div>
    );
};

export default CognitoLoginSimple;